import { Venue } from "./venue";

export enum InviteStatusEnum {
  Pending = 0,
  Accepted = 1,
  Expired = 2,
  Rejected = 3,
  Canceled = 4,
}

export interface Social {
  dinnerIntentByPosts: number;
  engagementRate: number;
  averageLikes: number;
  followersCount: number;
  profileUrl: string;
}

export interface FoodiePost {
  coverImg: string;
  socialMediaName: string;
  engagementRate: number;
  reach: number;
  socialMediaUrl: string;
  dinner: number;
  views: number;
  likes: number;
  ownerUsername: string;
  venueName: string;
  createdAt: string;
  performanceScore: number;
}

export interface BadFactors {
  collabCancellation: number;
  collabRescheduling: number;
  collabNoShow: number;
  missingUpload: number;
}

export interface GoodFactors {
  collabEngagement: number;
  uploadOnTime: number;
}

export interface Creator {
  foodieId: string;
  avatarUrl: string;
  isPremium: boolean;
  username: string;
  locations: string[];
  instagram: Social;
  tiktok: Social;
  dinnerIntentByPosts: number | null;
  commitmentRate: number;
  engagementRate: number;
  categories: string[];
  dietaryPreferences: string[];
  name: string;
  bio: string;
  engagementCPMPriceMax: number;
  engagementCPMPriceMin: number;
  posts: FoodiePost[];
  badFactors: BadFactors;
  goodFactors: GoodFactors;
  venue: Venue;
  inviteAvailable: boolean;
}
